import createReducer from "../../createReducer";
import { hubspotDataHandlers } from "../handlers";
import { IHubspotDataState } from "../types";

export const hubspotData: IHubspotDataState = {
    isLoading: false,
    error: null,
    hubspotData: null,
    success: false,
    message: "",
};

export default createReducer(hubspotData, hubspotDataHandlers);
